// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const meditite: PokeData = {
  "id": 307,
  "name": "meditite",
  "height": 6,
  "weight": 112,
  "base_experience": 56,
  "types": [
    PokeType.FIGHTING,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "pound",
    "psybeam",
    "low-kick",
    "counter",
    "confusion",
    "meditate",
    "recover",
    "bide",
    "high-jump-kick",
    "mind-reader",
    "reversal",
    "detect",
    "endure",
    "swagger",
    "hidden-power",
    "psych-up",
    "calm-mind",
    "feint",
    "acupressure",
    "power-trick",
    "force-palm",
    "zen-headbutt",
    "work-up"
  ],
  "moves": [
    "calm-mind",
    "zen-headbutt",
    "psy-pulse",
    "future-sight",
    "psychic-fangs",
    "drain-punch",
    "psy-ball",
    "karate-chop",
    "bulk-up",
    "meteor-assault",
    "coaching",
    "superpower",
    "double-kick"
  ],
  "evolution_chain": {
    "id": 152,
    "item": null,
    "species": [
      {
        "name": "meditite",
        "order": 333,
        "types": [
          PokeType.FIGHTING,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "medicham",
        "order": 334,
        "types": [
          PokeType.FIGHTING,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 307,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42.5,
    "speed": 60,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 180,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
